// @flow
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';
import DecimalFormInput from '../DecimalFormInput/DecimalFormInput';
import _ from 'lodash/fp';

export type Props = {
  editing: boolean,
  existing: any[],
  products: any[],
  variants: any[],
  change: Function,
  onSelectProduct: Function,
};

const LinkedAdditionalVariantForm = ({
  editing,
  existing,
  products,
  variants,
  change,
  onSelectProduct,
}: Props) => (
  <div className="LinkedAdditionalVariantForm">
    <Field
      name="product"
      label="Produkt"
      disabled={editing}
      deleteRemoves={false}
      normalize={value => {
        const id = value ? value.id : null;
        change('variant', null);
        onSelectProduct(id);
        return value;
      }}
      component={SelectFormInput}
      valueKey="id"
      labelKey="name"
      options={products} />
    <Field
      name="productVariant"
      label="Variant"
      disabled={editing}
      deleteRemoves={false}
      component={SelectFormInput}
      valueKey="id"
      labelKey="name"
      options={_.map(v => ({
        ...v,
        disabled: _.some(e => e.productVariant.id === v.id, existing),
      }), variants) } />
    <Field
      name="quantity"
      label="Antal"
      component={DecimalFormInput} />
    <Field
      name="note"
      label="Anteckning"
      component={TextAreaFormInput} />
  </div>
);

export default reduxForm({
  form: 'linkedAdditionalVariant',
  enableReinitialize: true,
})(LinkedAdditionalVariantForm);



// WEBPACK FOOTER //
// ./src/components/LinkedAdditionalVariantForm/LinkedAdditionalVariantForm.js